const EDIT_APP_COUNTRY_DRAFT_PREFIX = 'admin:appCountryDraft:edit:'
export const NEW_APP_COUNTRY_DRAFT_KEY = 'admin:appCountryDraft:new'
export const APP_COUNTRY_IMAGE_FILE_ACCEPT = '.jpg,.jpeg,.png,.gif,.webp,image/png,image/gif,image/jpeg,image/webp'
export const APP_COUNTRY_IMAGE_FILE_ERROR_MESSAGE = '이미지 파일만 업로드할 수 있습니다.'

// App 국가 이미지 업로드에서 허용하는 파일 형식만 통과시킨다.
export const isAppCountryImageFile = (file) => {
    return Boolean(file) && (
        (file.type && file.type.startsWith('image/')) ||
        /\.(jpg|jpeg|png|gif|webp)$/i.test(file.name || '')
    )
}

const getSessionStorage = () => {
    if (typeof window === 'undefined') {
        return null
    }

    return window.sessionStorage
}

const normalizeTextValue = (value) => {
    if (value === undefined || value === null) {
        return ''
    }

    return String(value)
}

// App 국가 폼은 이미지 파일을 제외한 선택/텍스트 필드만 sessionStorage에 남긴다.
export const createAppCountryDraftPayload = ({ params = {} } = {}) => {
    return {
        params: {
            continents: normalizeTextValue(params.continents),
            cCode: normalizeTextValue(params.cCode),
            lCode: normalizeTextValue(params.lCode),
            nameKr: normalizeTextValue(params.nameKr),
            nameEn: normalizeTextValue(params.nameEn),
            nameLo: normalizeTextValue(params.nameLo),
        }
    }
}

// 서버 기본값 위에 draft만 덮어써서 새로고침 뒤에도 국가 작성 흐름을 이어간다.
export const applyAppCountryDraft = ({ baseParams = {}, draft }) => {
    const normalizedBaseDraft = createAppCountryDraftPayload({
        params: baseParams,
    })

    if (!draft) {
        return {
            params: {
                ...baseParams,
                ...normalizedBaseDraft.params,
            },
        }
    }

    const draftParams = draft.params || {}

    return {
        params: {
            ...baseParams,
            continents: draftParams.continents === undefined
                ? normalizedBaseDraft.params.continents
                : normalizeTextValue(draftParams.continents),
            cCode: draftParams.cCode === undefined
                ? normalizedBaseDraft.params.cCode
                : normalizeTextValue(draftParams.cCode),
            lCode: draftParams.lCode === undefined
                ? normalizedBaseDraft.params.lCode
                : normalizeTextValue(draftParams.lCode),
            nameKr: draftParams.nameKr === undefined
                ? normalizedBaseDraft.params.nameKr
                : normalizeTextValue(draftParams.nameKr),
            nameEn: draftParams.nameEn === undefined
                ? normalizedBaseDraft.params.nameEn
                : normalizeTextValue(draftParams.nameEn),
            nameLo: draftParams.nameLo === undefined
                ? normalizedBaseDraft.params.nameLo
                : normalizeTextValue(draftParams.nameLo),
        }
    }
}

export const createEditAppCountryDraftKey = (countryId) => `${EDIT_APP_COUNTRY_DRAFT_PREFIX}${countryId}`

export const readAppCountryDraft = (draftKey) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return null
    }

    try {
        const storedValue = storage.getItem(draftKey)
        return storedValue ? JSON.parse(storedValue) : null
    } catch (_error) {
        return null
    }
}

export const saveAppCountryDraft = (draftKey, draftValue) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return
    }

    try {
        storage.setItem(draftKey, JSON.stringify(draftValue))
    } catch (_error) {
        // sessionStorage가 막혀 있어도 작성 흐름은 그대로 유지한다.
    }
}

export const clearAppCountryDraft = (draftKey) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return
    }

    try {
        storage.removeItem(draftKey)
    } catch (_error) {
        // storage 정리에 실패해도 화면 동작은 계속 진행한다.
    }
}
